import { Record } from 'immutable';
import { DateTime } from 'luxon';

export type EventObjectType = {
  datasetId: string;
  accountId: string;
  accountName: string;
  accountType: string;
  accountSubType: string;
  institutionId: string;
  institutionName: string;
  channel: string;
  brandingId: string;
  aggStatus: string;
  delta: string;
  isC2REnabled: boolean;
  isBankPendingTxnsEnabled: boolean;
  currentBalanceAsOf?: number;
  currentBalanceAsOfOn?: string;
  balanceAsOf?: number;
  balanceAsOfOn?: string;
  showRemindersUptoDays?: number;
  includePendingTxnInBalances?: boolean;
  txnCount?: number;
};


export interface AccountBalancesProps {
  accountId: string | null;
  accountType: string | null;
  currentBalance: number | null;
  onlineBalance: number | null;
  endingBalance: number | null;
  endingBalanceNoRecurring: number | null;
  finalBalance: number | null;
  goalsBalance: number | null;
  earliestTransactionDate: string | null | DateTime;
  txnsDeltaFromCurrentBalance: number | null;
  cpOnlineBalance?: number;
  cpAvailableBalance?: number;
  defaultBalance?: number;
}

export const AccountBalances = Record<AccountBalancesProps>({
  accountId: null,
  accountType: null,
  currentBalance: null,
  onlineBalance: null,
  endingBalance: null,
  endingBalanceNoRecurring: null,
  finalBalance: null,
  goalsBalance: null,
  earliestTransactionDate: null,
  txnsDeltaFromCurrentBalance: null,
  cpOnlineBalance: undefined,
  cpAvailableBalance: undefined,
  defaultBalance: undefined,
});

export const visibleBalances = [
  { label: "Today's Balance", key: 'sumCurrentAccountBalances', value: 'today' },
  { label: 'Online Balance', key: 'sumOnlineAccountBalances', value: 'online' },
  { label: 'Projected Balance', key: 'sumEndingAccountBalances', value: 'ending' },
];

export const schedTxViews = [
  { label: 'Next 7 Days', value: '7' },
  { label: 'Next 14 Days', value: '14' },
  { label: 'Next 30 Days', value: '30' },
  { label: 'Next 90 Days', value: '90' },
  { label: 'Next 12 months', value: '365' },
  { label: "Don't show reminders", value: '0' },
];

export const schedTxViewsMac = [
  { label: 'Next 7 Days', value: '7' },
  { label: 'Next 14 Days', value: '14' },
  { label: 'Next 30 Days', value: '30' },
  { label: 'Next 90 Days', value: '90' },
  { label: 'Next 6 months', value: '182' },
  { label: 'Next 12 months', value: '365' },
  { label: 'The next upcoming occurrence', value: '-1' },  // reminderDays === -1 means just the next occurrence (Mac only)
  { label: "Don't show reminders", value: '0' },
];

export const schedTxViewsWindows = [
  { label: 'Next 7 Days', value: '7' },
  { label: 'Next 14 Days', value: '14' },
  { label: 'Next 30 Days', value: '30' },
  { label: 'Next 90 Days', value: '90' },
  { label: 'Next 12 months', value: '365' },
  { label: "Don't show reminders", value: '0' },
];
